import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../Home/header/Header';
import Home from '../Home/home/Home';

const Main = () => {
    return (
        <div>
            <Header></Header>
            <Outlet></Outlet>
        </div>
    );
};

export default Main;